import { defineMessages } from 'react-intl';

const messages = defineMessages({
    moreInfo: {
        defaultMessage: 'More Info',
        description: 'Alt text for info icon',
        id: 'boxui.select.moreInfo',
    },
});

export default messages;
